module.exports = __webpack_public_path__ + "img/Indian.c05dd62b.svg";